import { Button, Form, Input, Typography } from "antd";
import { useLoaderData, useNavigate } from "react-router-dom";
import bevzLogo from "../../assets/v2/bevzLogo.png";
import style from "./ChangePassword.module.css";
import { useState } from "react";
import { postForgotPassword } from "../../components/apiRepository/DynamodbRepository";
import ErrorHandler from "../../helpers/ErrorHandler";

const { Title, Text, Paragraph } = Typography;

export function loader({ request }) {
  const url = new URL(request.url);
  const email = url.searchParams.get("email");
  return email;
}

export default function ForgotPasswordForm() {
  const email = useLoaderData();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      const res = await postForgotPassword(values);

      if (res?.errors?.length > 0) {
        throw new Error(res?.errors?.[0] || "Request Failed.");
      }

      const params = new URLSearchParams();
      params.set("email", values.email);

      navigate(`./requested?${params.toString()}`);
    } catch (error) {
      setLoading(false);

      setError(() =>
        ErrorHandler.handleErrors(
          error?.response?.data?.errors || error?.message || "Request Failed.",
        ),
      );
    }
  };

  return (
    <>
      <div style={{ marginBottom: "1.25rem" }}>
        <img alt="Bevz" src={bevzLogo} width="171px" height="115px" />
      </div>
      <Title style={{ fontSize: "30px", margin: 0 }}>Forgot Password</Title>
      <Paragraph
        style={{
          color: "#515151",
          fontSize: "16px",
          textAlign: "center",
          marginBottom: "3.125rem",
        }}
      >
        Please enter your Bevz email address to reset your password.
      </Paragraph>

      <Form
        autoComplete="off"
        requiredMark={false}
        layout="vertical"
        style={{ width: "100%" }}
        initialValues={{ email }}
        onFinish={handleSubmit}
      >
        <Form.Item
          label="Email Address"
          name="email"
          rules={[
            { required: true, message: "This is a required field." },
            {
              type: "email",
              message: "Please enter valid email address.",
            },
          ]}
        >
          <Input placeholder="your@email.com" size="large" />
        </Form.Item>

        <Paragraph
          style={{
            color: "#515151",
            fontSize: "16px",
            textAlign: "center",
            marginBottom: "3.125rem",
          }}
        >
          We’ll send a password reset link to this email.
        </Paragraph>

        <Paragraph style={{ textAlign: "center", marginBottom: 0 }}>
          <Text type="danger">{error}</Text>
        </Paragraph>

        <Form.Item label={null}>
          <Button
            size="large"
            htmlType="submit"
            className={style.BlueBrandButton}
            iconPosition="end"
            loading={loading}
          >
            Request Password Reset
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
